import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';
import { t } from '@/i18n';
import { CarrierAnnounce } from './CarrierAnnounce';
import { carrierToken } from '@/lib/announcements';

// Shows the carrier's announcement page in a phone frame next to the planner's view.
export const AnnouncePreview = ({ carrier, loadings, open, onOpenChange, onSaved }) => {
  if (!carrier) return null;
  const link = `/avizace/${carrierToken(carrier.id)}`;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{t('announce.previewTitle')}</DialogTitle>
          <div className="text-xs text-muted-foreground">{t('announce.previewHint')}</div>
        </DialogHeader>
        <div className="mx-auto w-full max-w-[340px] h-[560px] rounded-[2rem] border-[10px] border-slate-800 bg-slate-50 overflow-y-auto p-3">
          <CarrierAnnounce carrier={carrier} loadings={loadings} onSaved={onSaved} />
        </div>
        <Button asChild variant="outline" size="sm" className="gap-1">
          <a href={link} target="_blank" rel="noreferrer"><ExternalLink className="h-3.5 w-3.5" /> {t('announce.openLink')}</a>
        </Button>
      </DialogContent>
    </Dialog>
  );
};
